import type { Routes } from '@angular/router';
import { BusinessModule } from '../auth/common/enums/business/business-module';
import { AuthGuardAccess } from '../auth/common/enums/auth-guard-access';
import { authGuard } from '../auth/common/guards/auth.guard';
import { moduleGuard } from '../auth/common/guards/module.guard';
import { permissionGuard } from '../auth/common/guards/permission.guard';
import { ADMIN_PANEL_ROUTES } from './admin-panel/admin-panel.routes';
import { DashboardRoute } from './common/enums/dashboard-route';
import { DELEGATIONS_ROUTES } from './delegations/delegations.routes';
import { DRIVERS_ROUTES } from './drivers/drivers.routes';
import { FLEET_ROUTES } from './fleet/fleet.routes';
import { GANTT_ROUTES } from './gantt/gantt.routes';
import { MANAGEMENT_PANEL_ROUTES } from './management-panel/management-panel.routes';
import { MAP_ROUTES } from './map/map.routes';
import { ORDERS_ROUTES } from './orders/orders.routes';
import { SETTINGS_ROUTES } from './settings/settings.routes';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./common/components/dashboard-interface/dashboard-interface.component').then(
        (m) => m.DashboardInterfaceComponent,
      ),
    canActivate: [authGuard(AuthGuardAccess.DASHBOARD)],
    children: [
      {
        path: 'dashboard',
        redirectTo: DashboardRoute.GANTT,
      },
      {
        path: 'planner',
        children: GANTT_ROUTES,
      },
      {
        path: 'map',
        children: MAP_ROUTES,
      },
      {
        path: 'orders',
        children: ORDERS_ROUTES,
      },
      {
        path: 'delegations',
        canActivate: [moduleGuard(BusinessModule.DELEGATIONS)],
        children: DELEGATIONS_ROUTES,
      },
      {
        path: 'drivers',
        canActivate: [moduleGuard(BusinessModule.DRIVERS)],
        children: DRIVERS_ROUTES,
      },
      {
        path: 'fleet',
        canActivate: [moduleGuard(BusinessModule.FLEET)],
        children: FLEET_ROUTES,
      },
      {
        path: 'admin-panel',
        canActivate: [permissionGuard('adminPanel')],
        children: ADMIN_PANEL_ROUTES,
      },
      {
        path: 'management-panel',
        children: MANAGEMENT_PANEL_ROUTES,
      },
      {
        path: 'settings',
        children: SETTINGS_ROUTES,
      },
    ],
  },
] as const;
